<nz-card class="rounded-lg mt-3 p-4 mb-3 border-none shadow-sm hover:shadow-md transition-shadow" nzHoverable>
  <nz-skeleton *ngIf="loading" [nzLoading]="loading" [nzActive]="true"></nz-skeleton>

  <div *ngIf="!loading" class="py-1 text-xl font-semibold">Webhook QRISLY</div>

  <nz-tabset class="mt-4" [nzSelectedIndex]="selectedIndex"
    (nzSelectedIndexChange)="onSelectedIndexChange($event)">
    <nz-tab nzTitle="APK Webhook">
      <app-apk-webhook #apkWebhook></app-apk-webhook>
    </nz-tab>
    <nz-tab nzTitle="Outbound Webhook">
      <app-outbond-webhook #outbondWebhook></app-outbond-webhook>
    </nz-tab>
    <nz-tab nzTitle="Delivery History">
      <app-delivery-webhook #deliveryWebhook></app-delivery-webhook>
    </nz-tab>
  </nz-tabset>
</nz-card>
